export { default as FlipCards } from "./flip-cards-module";
